// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import {
  assembleQuery,
  fetchDefaultAFSFilterValues,
} from 'helpers/api'

const getMaxBuckRadius = async bandId => {
  const query = assembleQuery([{
    field: 'bandId',
    value: bandId,
  }])

  const { entity } = await fetchDefaultAFSFilterValues(query)

  return entity.buckDistanceKm
}

export default getMaxBuckRadius
